import React,{useState} from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout';
import { Link } from 'react-router-dom';
const Login = (props) => {
    const [credential, setcredential] = useState({email:"",password:""})
    const history = useNavigate();
  
    const handleSubmit= async(e)=>{
        e.preventDefault(); // to stop relaoding page
        const response = await fetch( "https://backened-8u4s2zadi-jharaghav3209-gmailcom.vercel.app/api/auth/login", {
            method: 'POST',
            
            headers: {
                'Content-Type': 'application/json',
                
                
            },
            
            body: JSON.stringify({ email:credential.email,password:credential.password })
        });
        const json = await response.json();
        if(json.success)
        {
            // save the auth token and redirect
            localStorage.setItem('token',json.token) ;
            localStorage.setItem('name',json.pasName);
            //localStorage is a property that allows JavaScript sites and apps to save key-value pairs in a web browser with no expiration date.
          history("/");
          props.showAlert("You are logged in Successfully","success")
        }
        else{
            props.showAlert("Invalid  Id","danger")
        }
     
    }
    const handleChange=(e)=>{
        setcredential({...credential,[e.target.name] : e.target.value})
    }
  return (
    <div>
        <form  onSubmit={handleSubmit}>
  <div className="mb-3">
    <label htmlFor="email" className="form-label">Email address</label>
    <input type="email" className="form-control" onChange={handleChange}  value={credential.email} id="email" aria-describedby="emailHelp"name="email" />
    <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
  </div>
  <div className="mb-3">
    <label htmlFor="password" className="form-label">Password</label>
    <input type="password" className="form-control" onChange={handleChange}  value={credential.password} id="password" name="password"/>
  </div>
  
  <Button type="submit" variant="contained" className="btn btn-primary" endIcon={<LogoutIcon/>}>Login</Button>
  <div className="mb-3 my-4">
        <p>Not a member? No Worry <Link to="/signup" style={{textDecoration:'none'}}>Register Here</Link></p>
      </div>
</form>
    </div>
  )
}

export default Login